import React from 'react';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import { PresentationMode } from '../../../../../../Enums/PresentationMode';
import { teamInfoFormId } from '../TeamInfo';
import SecondaryButton from '../../../../../../Elements/ids/Buttons/SecondaryButton';
import ModalPrimaryButton from '../../../../../../Elements/ids/Buttons/ModalPrimaryButton';
import PrimaryButton from '../../../../../../Elements/ids/Buttons/PrimaryButton';

const TeamInfoButtons = ({ closeView, closeError, canSubmit, modalMode }) => {
  return (
    <>
      <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeView} />

      {modalMode !== PresentationMode.Error ? (
        <ModalPrimaryButton formId={teamInfoFormId} canSubmit={canSubmit} text={formatMessage(Messages.common_save)} />
      ) : (
        <PrimaryButton text={formatMessage(Messages.common_ok)} onClickEvent={closeError} />
      )}
    </>
  );
};

export default TeamInfoButtons;
